var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "top" }, [
      _c(
        "span",
        {
          staticClass: "log",
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "tousujilu" })
            }
          }
        },
        [_vm._v("投诉记录")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form" },
      [
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("iccid/短号")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.iccid,
                expression: "form.iccid"
              }
            ],
            domProps: { value: _vm.form.iccid },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "iccid", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("联系人")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.name,
                expression: "form.name"
              }
            ],
            domProps: { value: _vm.form.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "name", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("联系电话")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.mobile,
                expression: "form.mobile"
              }
            ],
            domProps: { value: _vm.form.mobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "mobile", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-control" }, [
          _c("div", { staticClass: "label" }, [_vm._v("问题描述")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.desc,
                expression: "form.desc"
              }
            ],
            attrs: { rows: "10" },
            domProps: { value: _vm.form.desc },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "desc", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-control" },
          [
            _c("div", { staticClass: "label" }, [_vm._v("附件")]),
            _vm._v(" "),
            _c(
              "van-uploader",
              {
                attrs: {
                  "preview-size": "1.82rem",
                  "max-count": 6,
                  multiple: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "preview-cover",
                    fn: function(ref) {
                      var file = ref.file
                      return [
                        _c("div", { staticClass: "preview-cover" }, [
                          _vm._v(_vm._s(file.name))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.fileList,
                  callback: function($$v) {
                    _vm.fileList = $$v
                  },
                  expression: "fileList"
                }
              },
              [
                _c("div", { staticClass: "upload" }, [
                  _c("img", {
                    attrs: { src: require("../assets/images/jia_03.png") }
                  })
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "submit", on: { click: _vm.handleBindCard } },
          [_vm._v("确认提交")]
        ),
        _vm._v(" "),
        _vm.customerServiceInfo.customerServiceCode
          ? _c(
              "div",
              {
                staticClass: "openqrcode",
                on: {
                  click: function($event) {
                    _vm.showQrcode = true
                  }
                }
              },
              [_vm._v("联系客服专员")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "van-dialog",
          {
            attrs: { title: "客服微信" },
            model: {
              value: _vm.showQrcode,
              callback: function($$v) {
                _vm.showQrcode = $$v
              },
              expression: "showQrcode"
            }
          },
          [
            _c("div", { staticStyle: { padding: ".2rem" } }, [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: _vm.customerServiceInfo.customerServiceCode }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "font-size": ".24rem", "text-align": "left" }
                },
                [_vm._v(_vm._s(_vm.customerServiceInfo.customerServiceTime))]
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1445e589", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1445e589","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/feedback.vue
// module id = null
// module chunks = 